module.exports = __webpack_public_path__ + "static/media/importICS1.36ea4f73.png";